// Library Service for AI API Integration
import { aiAxiosInstance } from "../axios/aiAxiosConfig";
import { getCurrentUserFromLocalStorage } from "../helpers/localStorageHelper";
import { LIBRARY_API } from "../constants/ai-api-constants";

// AI API Base URL - có thể thay đổi từ environment variables
const AI_API_BASE_URL = process.env.AI_API_ENDPOINT;

class LibraryService {
  constructor() {
    this.currentUser = getCurrentUserFromLocalStorage();
    this.userId = this.getUserId();
    this.serverUserId = null; // Will be set from server-side props
  }

  // Initialize with server-side user data
  initializeUser(serverUserData) {
    if (serverUserData && serverUserData.userId) {
      this.serverUserId = serverUserData.userId;
    }
  }

  // Get effective user ID (prefer server-side, fallback to client-side)
  getEffectiveUserId() {
    return this.serverUserId || this.userId;
  }

  // Get user ID from various sources
  getUserId() {
    return this.currentUser.ssoId;
  }

  // Add item to library
  async addToLibrary(libraryData) {
    try {
      const requestBody = {
        user_id: this.getEffectiveUserId(),
        ...libraryData,
      };

      const response = await aiAxiosInstance.post(
        LIBRARY_API.ADD_TO_LIBRARY_API,
        requestBody
      );
      return response.data;
    } catch (error) {
      console.error(LIBRARY_API.ADD_TO_LIBRARY_ERROR_STRING, error);
      throw error;
    }
  }

  // Get user library
  async getUserLibrary(params = {}) {
    try {
      const queryParams = new URLSearchParams({
        user_id: this.getEffectiveUserId(),
        ...params,
      });

      const response = await aiAxiosInstance.get(
        `${LIBRARY_API.GET_USER_LIBRARY_API}?${queryParams}`
      );
      return response.data;
    } catch (error) {
      console.error(LIBRARY_API.GET_USER_LIBRARY_ERROR_STRING, error);
      throw error;
    }
  }

  // Update library metadata
  async updateLibraryMetadata(libraryData) {
    try {
      const requestBody = {
        user_id: this.getEffectiveUserId(),
        ...libraryData,
      };

      const response = await aiAxiosInstance.put(
        LIBRARY_API.UPDATE_LIBRARY_METADATA_API,
        requestBody
      );
      return response.data;
    } catch (error) {
      console.error(LIBRARY_API.UPDATE_LIBRARY_METADATA_ERROR_STRING, error);
      throw error;
    }
  }
}

// Create singleton instance
const libraryService = new LibraryService();

// Export functions

export const addToLibrary = async (libraryData) => {
  const service = new LibraryService();
  return await service.addToLibrary(libraryData);
};

export const getUserLibrary = async (params) => {
  const service = new LibraryService();
  return await service.getUserLibrary(params);
};

export const updateLibraryMetadata = async (libraryData) => {
  const service = new LibraryService();
  return await service.updateLibraryMetadata(libraryData);
};

export default libraryService;
